<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kk0AKB/tc-custom/9781426857782.jpg?1726617321251" alt="This image is the cover for the book Greek's Bought Wife, Wedlocked!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Greek's Bought Wife, Wedlocked!
      </h1>
      <p class="bookDescription body article font2">
        <p>Nic Leandros knows that most people want only his money. So when he finds out beautiful Tina Matheson is pregnant with his late brother's child, he's certain her price will be high….<br/><br/>However, Tina must agree to his terms: no Leandros heir has ever been born out of wedlock; they will marry for the baby's sake….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Bianchin
      </h2>
      
      <p class="authorDescription body article">Helen Bianchin was encouraged by a friend to write her own romance novel and she hasn&rsquo;t stopped writing since! Helen&rsquo;s interests include a love of reading, going to the movies, and watching selected television programs. She also enjoys catching up with friends, usually over a long lunch! A lover of animals, especially cats, she owns two beautiful Birmans. Helen lives in Australia with her husband. Their three children and six grandchildren live close by.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?361cceae